import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import queryString from "query-string";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";

class ExternalLinks extends Component {
    getIdFromQuery = () => {
        const pageParams = queryString.parse(this.props.location.search);
        return pageParams.id;
    };

    renderLink = l => {
        return (
            <li key={l.MenuID}>
                <a href={l.AppCommand.CommandParams.ExternalLink}>{l.Text}</a>
            </li>
        );
    };

    render() {
        let id = this.getIdFromQuery();
        if (!id) {
            return null;
        }

        let headItem = this.props.menuItems.filter(mi => mi.MenuID === id);
        if (headItem.length === 0) {
            return null;
        }
        let title = headItem[0].Text;

        let linksArr = this.props.menuItems.filter(mi =>
            mi.ParentID === id
            && mi.AppCommand
            && mi.AppCommand.CommandParams
            && mi.AppCommand.CommandParams.ExternalLink
        );
        if (linksArr.length === 0) {
            return null;
        }

        return (
            <PlaceholderWrapper placeholderId={id}
                                title={<><i className='fa fa-external-link'/> {title}</>}
                                staticTitle={title}
                                canCollapse={false}
                                menuId={id}>
                <ul>
                    {linksArr.map(l => this.renderLink(l))}
                </ul>
            </PlaceholderWrapper>
        );
    }
}

ExternalLinks.propTypes = {
    dispatch: PropTypes.func.isRequired,
    menu: PropTypes.object
};

ExternalLinks.defaultProps = {};

function mapStateToProps(state) {
    return {
        menuItems: state.appState.appParams.menu.Items
    };
}

export default withRouter(connect(mapStateToProps)(ExternalLinks));